import classnames from 'classnames/bind';
import moment from 'moment';
import PropTypes from 'prop-types';
import React from 'react';

import overrideStyle from 'lib/overrideStyle';
import styles from 'presentation/components/styles/Message.css';
let cx = classnames.bind(styles);

class Datestamp extends React.Component {
  constructor(props) {
    super(props);

    const DatestampPropTypes = {
      timestamp: PropTypes.instanceOf(Date),
    };
    PropTypes.checkPropTypes(DatestampPropTypes, props, 'prop', 'Datestamp');
  }

  render() {
    if (!this.props.timestamp) {
      return;
    }

    let classes = cx('message_timestamp');

    return <Wrapper className={classes}>{formatDatestamp(this.props.timestamp)}</Wrapper>;
  }
}

export default Datestamp;

// https://momentjs.com/docs/#/displaying/format/
export function formatDatestamp(date) {
  if (moment(date).diff(moment(), 'year')) {
    return moment(date)
      .format('MMM DD, YYYY')
      .toUpperCase();
  }
  return moment(date)
    .format('MMM, DD')
    .toUpperCase();
}

const Wrapper = overrideStyle('div')`
  font-family: ${p => p.theme.fontLibrary.primary};
  padding: 10px 0 15px 0;
  text-align: center;
`;
